export default __webpack_public_path__ + "static/media/Knife_1.7cbcf891.png";